module.exports = __webpack_public_path__ + "img/hr-puberty-decal-19.54017ec7.png";